import { getApis } from './core';

export const signIn = async () => {
  const { gapi } = getApis();
  const auth2 = gapi.getAuthInstance();
  const googleUser = await auth2.signIn();
  return googleUser.getAuthResponse(true).access_token;
};
